export default function IconTrash() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.31707 10.1333C9.91024 10.1333 10.3902 10.6104 10.3902 11.2V17.8667C10.3902 18.4562 9.91024 18.9333 9.31707 18.9333C8.72391 18.9333 8.2439 18.4562 8.2439 17.8667V11.2C8.2439 10.6104 8.72391 10.1333 9.31707 10.1333Z"
        fill="currentColor"
      />
      <path
        d="M14.6829 10.1333C15.2761 10.1333 15.7561 10.6104 15.7561 11.2V17.8667C15.7561 18.4562 15.2761 18.9333 14.6829 18.9333C14.0898 18.9333 13.6098 18.4562 13.6098 17.8667V11.2C13.6098 10.6104 14.0898 10.1333 14.6829 10.1333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3415 0C15.4155 0 17.0976 1.67187 17.0976 3.73333V5.06667H21.9268C22.52 5.06667 23 5.54376 23 6.13333C23 6.72291 22.52 7.2 21.9268 7.2H21.122V18.9333C21.122 21.7312 18.8394 24 16.0244 24H7.97561C5.16068 24 2.87805 21.7313 2.87805 18.9333V7.2H2.07317C1.48 7.2 1 6.72291 1 6.13333C1 5.54376 1.48 5.06667 2.07317 5.06667H6.90244V3.73333C6.90244 1.67187 8.5845 0 10.6585 0H13.3415ZM5.02439 18.9333C5.02439 20.5531 6.34595 21.8667 7.97561 21.8667H16.0244C17.6541 21.8667 18.9756 20.5531 18.9756 18.9333V7.2H5.02439V18.9333ZM10.6585 2.13333C9.76982 2.13333 9.04878 2.85 9.04878 3.73333V5.06667H14.9512V3.73333C14.9512 2.85 14.2302 2.13333 13.3415 2.13333H10.6585Z"
        fill="currentColor"
      />
    </svg>
  );
}
